import { z } from 'zod';
import { RubricBankItemCriteria } from 'libs/end-to-end/src/types/rubric-bank/rubric-bank-item-criteria';
import { UnixTimestamp } from 'libs/end-to-end/src/types/databases/analysis/database-analysis';

export const RubricBankItem = z.object({
  id: z.string(),
  name: z.string(),
  criteria: z.array(RubricBankItemCriteria),
  createdBy: z.string(),
  createdAt: UnixTimestamp,
  updatedAt: UnixTimestamp.nullable(),
});

export type RubricBankItem = z.infer<typeof RubricBankItem>;

export const RubricBankItemForWrite = RubricBankItem.omit({
  id: true,
});

export type RubricBankItemForWrite = z.infer<typeof RubricBankItemForWrite>;
